define('widgets/splitValue/viewmodel',['knockout', 'underscore'], function (ko, _) {
    var SplitValue = function() {
        var self = this;

        self.splitValue = ko.pureComputedArray(function() {

            var value = ko.unwrap(self.field.value) || '',
                placeholder = ko.unwrap(self.placeholder) || '',
                minLength = placeholder.length;

            return _.map(
                _.str.rpad(value, minLength).split(''),
                function(val, i) {
                    return {
                        value: val.trim(),
                        placeholder: placeholder[i]
                    };
                }
            );
        });
    };

    SplitValue.prototype.activate = function(settings) {
        this.field = settings.field;
        this.label = settings.label;
        this.placeholder = settings.placeholder;
        this.instructions = settings.instructions;

        settings.parent.classList.add('block');
    };

    return SplitValue;
});

